module.exports = __webpack_public_path__ + "static/img/Schaar.5eab624.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Schaar.png
// module id = QaXW
// module chunks = 2